<template>
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false">
        <div class="history-data-dialog">
            <div v-if="historyFormList.length"
                class="history-data">
                <div class="history-title">查看历史</div>
                <div class="history-content">
                    <van-list :finished="listStatus.finished"
                        :finished-text="finishedText"
                        :error.sync="listStatus.error"
                        error-text="请求失败，点击重新加载"
                        :immediate-check="false">
                        <div v-for="(item, index) in historyFormList"
                            :key="index"
                            class="history-form-list">
                            <img src="static/runtime/images/magic/time.png" />
                            <div class="submit-time">
                                <div class="time">{{item.creationDate}}</div>
                                <div class="query-btn"
                                    @click="goDetail(item)">查看</div>
                            </div>
                        </div>
                        <div v-if="showSelectMore"
                            class="select-more"
                            @click="getNextPage">查看更多</div>
                    </van-list>
                </div>
            </div>
            <div v-else
                class="no-data">
                <img class="no-data-img"
                    src="static/image/activityPaused.png" />
                <div class="tips">暂无历史数据</div>
            </div>
            <div class="closeDialog">
                <div class="icon">
                    <van-icon name="cross"
                        @click="closeHistoryModal" />
                </div>
            </div>

        </div>
    </van-dialog>
</template>

<script>
import { List, Dialog, Toast, Icon } from 'vant';

export default {
  components: {
    [List.name]: List,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
  },
  data() {
    return {
      isVisibility: false,
      historyFormList: [],
      listStatus: {
        finished: false,
        error: false,
      },
      page: {
        curPage: 1,
        pageSize: 5,
        totalRows: 0,
      },
      finishedText: '',
      activityCode: '',
      showSelectMore: false,
    };
  },
  methods: {
    openModel(data) {
      this.activityCode = data.activityCode;
      this.historyFormList = [];
      this.page = {
        curPage: 1,
        pageSize: 5,
        totalRows: 0,
      };
      this.finishedText = '';
      this.listStatus = {
        finished: false,
        error: false,
      };
      this.queryHistoryData();
    },
    queryHistoryData() {
      Toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0, // 默认值为2秒，设置为0，表示不会消失，需手动清除
      });
      const params = {
        curPage: this.page.curPage,
        pageSize: this.page.pageSize,
        filter: this.activityCode,
        language: 'Cn',
        timezone: 'Asia/Shanghai',
      };

      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: `/questionActivity/historyQuestionAnswerList`,
        params: params,
        success: (res) => {
          Toast.clear();
          console.log('res===>', res);
          const { result } = res;
          this.isVisibility = true;
          if (res.code === 200 && result) {
            const list = result || [];
            if (list.length > 0) {
              this.page.totalRows = list[0].pagingMap.totalRows;
            }
            this.historyFormList = this.historyFormList.concat(list);
            if (this.historyFormList.length < this.page.totalRows) {
              this.showSelectMore = true;
            } else {
              this.showSelectMore = false;
              this.listStatus.finished = true;
              this.finishedText = '没有更多了';
            }
          } else {
            Toast(res.message);
          }
        },
        failure: () => {
          Toast.clear();
          Toast('出错了，请稍后再试');
        },
      });
    },
    getNextPage() {
      this.page.curPage++;
      this.queryHistoryData();
    },
    goDetail(item) {
      const data = {
        activityCode: this.activityCode,
        connectionId: item.connectionId,
      };
      this.isVisibility = false;
      this.$emit('goDetail', data);
    },
    closeHistoryModal() {
      this.isVisibility = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.history-data-dialog {
  width: 82.7%;
  z-index: 1000;
  .history-data {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 12.5px;
    background: #ffffff;
    padding: 21px 6px 21px 16px;
    .history-title {
      font-size: 18px;
      color: #000000;
      margin-bottom: 10px;
    }
    .history-content {
      width: 100%;
      max-height: 360px;
      overflow: scroll;
      padding-right: 10px;
      .history-form-list {
        background: #f2f3f5;
        border-radius: 3px;
        padding: 0 9px;
        height: 55px;
        margin: 0 auto;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        img {
          width: 35px;
          height: 35px;
          margin-right: 9px;
        }
        .submit-time {
          display: flex;
          justify-content: space-between;
          width: 100%;
          .time {
            font-size: 14px;
            color: #333333;
          }
          .query-btn {
            width: 58px;
            height: 24px;
            color: #256fff;
            border: 1px solid rgba(37, 111, 255, 1);
            border-radius: 11.5px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    .select-more {
      text-align: center;
      color: #256fff;
    }
  }
  .no-data {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12.5px;
    background: #ffffff;
    padding: 15px;
    box-sizing: border-box;
    .no-data-img {
      width: 50.1vw;
      height: 37.87vw;
      margin-bottom: 20px;
    }
    .tips {
      font-size: 14px;
      color: #000000;
      text-align: center;
      font-weight: 400;
    }
  }
  .closeDialog {
    display: flex;
    justify-content: center;
    .icon {
      width: 30px;
      height: 30px;
      border: 1px solid white;
      border-radius: 50%;
      color: white;
      position: absolute;
      font-size: 22.5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/select-history-form-dialog.vue